// Copyright (c) 2023 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDuplicatePinPlate} from '../../shared/repositories';

export const readDuplicatePinPlate = selectedAccounts =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const status = ['SUBMITTED', 'SHIPPED'];
            const duplicatePinPlatePaylod =
                {accounts: selectedAccounts,
                    status};

            const duplicatePinPlateChanges = await getDuplicatePinPlate(duplicatePinPlatePaylod);

            dispatch({
                data: duplicatePinPlateChanges,
                type: actions.UPDATE_TCSM_DUPLICATE_PIN_PLATE
            });

            dispatch({
                length: duplicatePinPlateChanges.length,
                type: actions.UPDATE_TCSM_DUPLICATE_PIN_PLATE_LENGTH
            });

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/get-duplicate-pin-plate.js